import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { ImageOff } from "lucide-react";
import { getDesign } from "../../api/CanvaApi";

interface CanvaViewProps {
  fileId: string;
  className?: string;
  onLoad?: () => void;
  onError?: () => void;
}

const CanvaView = ({ fileId, className, onLoad, onError }: CanvaViewProps) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const { data, isLoading } = useQuery({
    queryKey: ["canva", fileId],
    queryFn: async () => {
      const data = await getDesign(fileId);
      return data?.design || null;
    },
    enabled: !!fileId,
    staleTime: 60 * 1000, // cache 60s
  });

  useEffect(() => {
    // Check if image is already loaded (from cache)
    if (imgRef.current?.complete && data?.thumbnail?.url && onLoad) {
      onLoad();
    }
  }, [data, onLoad]);

  if (isLoading || !data || !data.thumbnail?.url) {
    return (
      <div className="w-full h-full justify-items-center content-center">
        <ImageOff className="text-gray-600" />
      </div>
    );
  }

  return (
    <img
      ref={imgRef}
      src={data.thumbnail.url}
      alt={data.title}
      className={className}
      onLoad={onLoad}
      onError={onError}
    />
  );
};

export default CanvaView;
